import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { selectUser } from '@/store/selectors/userSelectors';
import {
  COUNTRY_CODE_CANADA,
  SUBDIVISION_CODE_ALBERTA,
  envIsCanada,
  envIsNormal,
  matchesRegion,
} from '@/constants/constants';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

export function useAlbertaLoginMigration(): void {
  const { openModal } = useModal();
  const user = useSelector(selectUser);
  const seen = useRef(false);

  useEffect(() => {
    if (!envIsNormal() && !envIsCanada()) {
      return;
    }

    if (
      user &&
      matchesRegion(user.countryCode, COUNTRY_CODE_CANADA) &&
      matchesRegion(user.subdivision.code, SUBDIVISION_CODE_ALBERTA) &&
      !seen.current
    ) {
      seen.current = true;
      openModal(MODALS.ALBERTA_LOGIN_MIGRATION);
    }
  }, [user]);
}
